export default __webpack_public_path__ + "static/media/Gears-75ms.f5811823.gif";